import { Avatar, Box, Typography, IconButton, AppBar, useTheme, Popper, ClickAwayListener, Card, Divider, Tooltip, Button } from "@mui/material"
import { Link, useNavigate } from "react-router-dom"
import { useState } from "react"

import { useLayoutContext } from "../../../contexts/layout.context"
import { useThemeContext } from "../../../contexts/theme.context"
import { useUserStore } from "../../../store/user.store"
import { useAuthStore } from '../../../store/auth.store'
import aliveLogo from '../../../assets/alivelogo.png'
import simbaImg from '../../../assets/Habba-Logo.png'
import { Icons } from "../../../utils/utilities"

const themeOptions = [
    { value: 'light', icon: Icons.default.LightMode, label: 'light' },
    { value: 'dark', icon: Icons.default.DarkMode, label: 'dark' },
    { value: 'system', icon: Icons.default.SystemTheme, label: 'system' },
]

const Navbar = ( { openSideMenu, closeSideMenu } ) => {

    const [settingsAnchorEl, setSettingsAnchorEl] = useState( null )

    const UserStore = useUserStore()
    const AuthStore = useAuthStore()

    const navigate = useNavigate()
    const { active, navHeight, navHeadText } = useLayoutContext()

    const { palette, border } = useTheme()
    const { setSelectedTheme, selectedTheme } = useThemeContext()

    const handleThemeChange = value => {
        setSelectedTheme( value )
        localStorage.setItem( 'preferedTheme', value )
        setSettingsAnchorEl( null )
    }

    return (
        <AppBar
            id="appbar"
            elevation={0}
            sx={{
                borderRadius: "0",
                background: "transparent",
                transition: "0.2s ease-out",
                position: "static",
                color: palette.nav.font,
                height: { sm: "50px", xs: "60px" },
                zIndex: "1220"
            }}
        >
            {/* <Typography fontSize="12px" sx={{ position: "absolute", top: 0, left: 0, right: 0, background: palette.warning.main, color: palette.warning.contrastText }}>Under maintenance</Typography> */}
            <Box alignItems="center" justifyContent="space-between" height={`${navHeight}px`} padding={{ sm: "0 20px 0 0", xs: "0 10px 0 10px" }} display="flex" maxWidth="100%" id="app-bar" sx={{ transition: "0.2s ease-out" }}>
                <Box display="flex" gap="10px" alignItems="center">
                    <Box padding="2px" display={{ sm: "none", xs: "flex" }} alignItems="center" justifyContent="center" borderRadius="5px" sx={{ aspectRatio: "1 / 1" }} bgcolor="white">
                        <Box component="img" width="30px" src={aliveLogo} alt="Logo" />
                    </Box>
                    <Box display={{ sm: "block", xs: "none" }} component="img" src={simbaImg} width="20px" />
                    <Typography display={{ sm: "block", xs: "none" }} component='h1' fontSize="14px" color={palette.nav.font} >
                        Acharya LMS
                    </Typography>
                    <Typography display={{ sm: "block", xs: "none" }} component='span' fontSize="14px" color={palette.nav.font} >
                        |
                    </Typography>
                    <Typography color={palette.nav.font} component="span" fontSize={{ md: "14px", xs: "14px" }} >{navHeadText || `Welcome to digital classrooms`}</Typography>
                </Box>
                {<Box display="flex" alignItems="center" gap="10px">
                    <Box display={{ sm: "block", xs: "none" }}>
                        <Typography textAlign="right" variant='subtitle2' textTransform="capitalize">{UserStore.getUser["user_name"] || ""}</Typography>
                    </Box>

                    {/* {( UserStore.getUser.user_role?.match( /^admin$/ig ) || ( UserStore.getUser.user_role?.match( /^subadmin$/ig ) && UserStore.getUser?.user_permissions?.auditing === true ) ) && <Box onClick={toggleAuditMode} display={{ md: "flex", xs: "none" }} gap="10px" alignItems="center" sx={{ cursor: "pointer" }} padding="5px 10px" border={border[1]} bgcolor={palette.common.bg} borderRadius="10px">
                        <Typography variant="subtitle2" color="primary">Audit Mode</Typography>
                        <CustomSwitch checked={active.startsWith( '/audit' )} />
                    </Box>} */}
                    <IconButton onClick={( e ) => setSettingsAnchorEl( e.currentTarget )}>
                        <Avatar src={UserStore.getUser.user_profile} sx={{ height: "32px", width: "32px" }}></Avatar>
                    </IconButton>

                    <Popper sx={{ zIndex: 100 }} placement='bottom' open={Boolean( settingsAnchorEl )} anchorEl={settingsAnchorEl}>
                        <ClickAwayListener onClickAway={() => setSettingsAnchorEl( null )}>
                            <Card sx={{ marginTop: "10px", marginRight: "20px", border: border[1], borderRadius: "5px" }} elevation={1} >
                                <Box display="flex" alignItems="center" gap="5px" padding="5px">
                                    <Avatar onClick={( e ) => setSettingsAnchorEl( e.currentTarget )} sx={{ height: "30px", width: "30px", borderRadius: "5px" }}></Avatar>
                                    <Box>
                                        <Typography display="block" lineHeight={1.3} fontSize="14px" variant='subtitle2'>{UserStore.getUser["name"] || UserStore.getUser["user_name"] || UserStore.getUser["employee_name"] || UserStore.getUser["student_name"] || ""} </Typography>
                                        <Typography display="block" lineHeight={1.3} fontSize="12px" color='textSecondary' variant='subtitle2' >{UserStore.getUser["AUID"] || UserStore.getUser["empcode"] || UserStore.getUser["user_id"] || ""}</Typography>
                                    </Box>
                                </Box>
                                <Divider />
                                <Box padding="5px" justifyContent="space-between" display="flex" gap="20px" alignItems="center">
                                    <Box display="flex" gap="10px" alignItems="center">
                                        {Icons.default.PaletteOutlined}
                                        <Typography width="max-content" display="flex" fontSize="12px" variant="variant2">
                                            Theme
                                        </Typography>
                                    </Box>
                                    <Box borderRadius="20px" bgcolor={palette.contentBg} padding="5px" display="flex" gap="2px" position="relative" alignItems="center">

                                        <Box position="absolute" bgcolor={palette.background.paper} borderRadius="50%" top="5px" bottom="5px" left={`${5 + ( themeOptions.findIndex( to => to.value === selectedTheme ) * 30 )}px`} height="calc(100% - 10px)" sx={{ aspectRatio: "1 / 1", transition: "all 300ms" }} />

                                        {themeOptions.map( theme => (
                                            <Tooltip disableInteractive key={theme.value} title={theme.label} >
                                                <IconButton onClick={() => handleThemeChange( theme.value )} size='small' >
                                                    {theme.icon}
                                                </IconButton>
                                            </Tooltip>
                                        ) )}
                                    </Box>
                                </Box>
                                <Divider />
                                <Box padding="5px">
                                    <Link to={`/admin`}  ><Button onClick={() => AuthStore.doLogout()} startIcon={Icons.default.Logout} color='error' size='small' fullWidth variant='contained' disableElevation >Logout</Button></Link>
                                </Box>
                            </Card>
                        </ClickAwayListener>
                    </Popper>
                </Box>}
            </Box>
        </AppBar>
    )
}

export default Navbar
